import { mapDTO } from '@twistezo/ts-dto-mapper'

import { floatPercentToDTO } from 'utils/number'
import { Schema } from '../../../schema'
import { Variables } from './types'

export const toDTO = (from: Schema): Variables =>
  mapDTO<Schema, Variables>({ from }).transform((data: Schema): Variables => {
    const { allowActivitiesData, s2sTimeoutMultiplier } = data

    return {
      ...data,
      allowActivitiesData: allowActivitiesData.length > 0 ? allowActivitiesData : null,
      s2sTimeoutMultiplier: floatPercentToDTO(s2sTimeoutMultiplier),
    }
  })
